// extracted by mini-css-extract-plugin
module.exports = {"loginFormWrapper":"Login_loginFormWrapper__1Fedm","divStyleOpen":"Login_divStyleOpen__2w9m8","divStyleClosed":"Login_divStyleClosed__VCVsd"};